import { render } from "./LostDamagedModal.vue?vue&type=template&id=3c673398"
import script from "./LostDamagedModal.vue?vue&type=script&lang=js"
export * from "./LostDamagedModal.vue?vue&type=script&lang=js"

import "./LostDamagedModal.vue?vue&type=style&index=0&id=3c673398&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__